import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/client/work-bench'

const ADVER = '/rest/tourist/shop/advertisement?type=2' // 广告
const SUMMARY = '/rest/customer/report/item-consumptions/summary' // 投放情况
const INDUS = '/rest/tourist/marketing-service' // 行业资讯
const ARTICLE = '/rest/tourist/customer-home-article' // 企业动态
const GOOD = '/rest/tourist/shop/customer-score-goods/pool/{type}' // 商品
const CHANGFIRST = '/rest/support/authorization/setFirstLogin'

export default {
  getSummary ({search}, cb) {
    http.get(SUMMARY, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getAdver (cb) {
    http.get(ADVER).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getIndusStr (cb) {
    http.get(INDUS).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getArticle (cb) {
    http.get(ARTICLE).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getGood (cb) {
    http.get(GOOD.replace('{type}', 0)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  changeFirstLogin (cb) {
    http.post(CHANGFIRST).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/work-bench.js